import { render } from "./PlanMask.vue?vue&type=template&id=6671c794"
import script from "./PlanMask.vue?vue&type=script&lang=js"
export * from "./PlanMask.vue?vue&type=script&lang=js"

import "./PlanMask.vue?vue&type=style&index=0&id=6671c794&lang=scss"

import exportComponent from "/data/projects/dev_private_futurelab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__